import AsyncStorage from '@react-native-async-storage/async-storage';
import React, { Context, createContext, useReducer, useEffect } from "react";
import { Platform } from 'react-native';
import { AnalyticsService } from "../../constants/Analytics";
import { SafeJSONObject } from '../../constants/Utils';
import http from '../../utils/http';
import Reducer from './Reducer'

const analytics = new AnalyticsService()

const initialState = {
    isLoading: true,
    isSignout: false,
    userToken: null,
    userId: null,
    buyerId: null,
    buyerData: null,
    signupData: null,
    chat_instance: null,
    install_prompt: null
};

interface ISignInProp {
    _id: string,
    token: string,
    buyerData: any
}

const AuthStore = ({ ...props }) => {

    const [state, dispatch] = useReducer(Reducer, initialState);

    const authContext = {
        signIn: async (args: ISignInProp) => {
            const { _id, token, buyerData} = args

            await AsyncStorage.setItem('userToken', token);
            await AsyncStorage.setItem('buyerId', _id);
            await AsyncStorage.setItem('buyerData', JSON.stringify(buyerData));

            dispatch({
                type: 'SIGN_IN',
                token: token,
                buyerId: _id,
                buyerData: buyerData,
            });

        },
        signOut: async () => {
            await AsyncStorage.clear();

            analytics.logEvent('Logged Out', state.buyerData, {})

            let data = new FormData()
            data.append('token', state.userToken)
            http.post('user_session/invalidate', data, state.userToken)
                .then(res => {
                    // console.log(res)
                    // do nothing
                })
                .catch(err => console.log(err))

            dispatch({ type: 'SIGN_OUT' })
        },
        signUp: async (data: any) => {

            await AsyncStorage.setItem('userToken', data.token);

            let signup_data: any = await AsyncStorage.getItem('signupData')
            signup_data = JSON.parse(signup_data)
            signup_data = signup_data || {}
            if (!signup_data[data.userId]) {
                signup_data[data.userId] = {
                    user_id: data.userId
                }
            }
            await AsyncStorage.setItem('signupData', JSON.stringify(signup_data));

            dispatch({
                type: 'SIGN_UP',
                token: data.token,
                userId: data.userId,
                signupData: signup_data
            });

        },
        updateUserData: async (data: any) => {
            await AsyncStorage.setItem('buyerData', JSON.stringify(data));

            dispatch({
                type: 'UPDATE_USER',
                buyerData: data
            });
        },
        setChatInstance: (chat_instance: any) => {
            dispatch({
                type: 'SET_CHAT_INSTANCE',
                payload: chat_instance
            })
        },
        getUserData: state,
        state: state,
    }

    const restoreSession = async () => {
        let userToken = await AsyncStorage.getItem('userToken');
        if (userToken) {
            let buyerId = await AsyncStorage.getItem('buyerId');
            let userId = await AsyncStorage.getItem('userId');
            let buyerData = await AsyncStorage.getItem('buyerData');
            let signupData = await AsyncStorage.getItem('signupData');
            // allow user continue on the app while token validation proceeds
            dispatch({
                type: 'RESTORE_TOKEN',
                token: userToken,
                userId: userId,
                buyerId: buyerId,
                buyerData: SafeJSONObject(buyerData),
                signupData: SafeJSONObject(signupData),
            });
        }
    }

    useEffect(() => {
        restoreSession();
        if (Platform.OS === 'web') {
            if ('serviceWorker' in navigator) {
                window.addEventListener('beforeinstallprompt', promptObject => {
                    // Enable button here
                    dispatch({
                        type: 'SET_INSTALL_PROMPT',
                        payload: promptObject
                    })
                });
                window.addEventListener('appinstalled', () => {
                    // TODO: send analytics event to indicate successful install
                    // console.log('PWA was installed');

                    // Hide the app-provided install promotion
                    // Clear the deferredPrompt so it can be garbage collected
                    dispatch({
                        type: 'SET_INSTALL_PROMPT',
                        payload: null
                    })
                });

                navigator.serviceWorker.getRegistration().then(async function (reg) {
                    // check registered sw
                    if (reg) {
                        // update sw
                        await reg.update()
                    }
                });
            }
        }

        return () => {
            if (Platform.OS === 'web') {
                window.removeEventListener('beforeinstallprompt', () => { })
                window.removeEventListener('appinstalled', () => { })
            }
        }
    }, [])

    return <AuthContext.Provider value={authContext}>
        {props.children}
    </AuthContext.Provider>
};

export const AuthContext = createContext<any | null>(null);
export default AuthStore;
